import Modal from 'react-bootstrap/lib/Modal';
import React from 'react';

const closeIcon = require('assets/icons/close.svg');
import { formatText, HtmlText } from 'core/i18n';
require('../../../styles/blocks/_modal.scss');
require('./cancellationModal.scss');

export const CancellationModal = ({ isOpen, close, onConfirm }) => (
    <Modal
        show={isOpen}
        className="ra-modal-override cancellation-modal"
        dialogClassName="ra-modal"
        backdrop="static"
        animation={true}
    >
        <Modal.Header>
            <div className="close-icon">
                <a href="#" onClick={close}>
                    <img src={closeIcon} />
                </a>
            </div>
            <div className="title">
                <h5>{formatText('loanCancel-title_ares')}</h5>
            </div>
        </Modal.Header>
        <Modal.Body>
            <div>{HtmlText(formatText('loanCancel-text_ares'))}</div>
        </Modal.Body>
        <Modal.Footer>
            <div className="options-area">
                <button className={'close-button'} onClick={close}>
                    {formatText('loanCancel-cancel_ares')}
                </button>
                <button className={'form__button form__button-secondary'} onClick={onConfirm}>
                    {formatText('button-understood')}
                </button>
            </div>
        </Modal.Footer>
    </Modal>
);
